import { useTranslation } from "@coworker/locales";
import hfbNumbers from "@coworker/app/src/components/InputPopup/UserFiltersRow/hfbNumbers.json";
import { FilterType, InputType } from "../../shared/filters/types/filter";
import { useAllSelectOption } from "../../shared/filters/utils/useAllSelectOption";

const HFB_ID = "hfb";

export function useHfbSelectFilter(title?: string) {
  const { t } = useTranslation();
  const defaultValue = { filterId: HFB_ID, value: "" };

  const filteredHfbNumbers = hfbNumbers.filter(
    (hfb) => !["61", "60"].includes(hfb)
  );

  const hfbs = [...filteredHfbNumbers, "SFM"];

  function getOptions() {
    const options = hfbs.map((hfb) => ({
      value: hfb,
      title:
        t(hfb === "SFM" ? "SFMString" : `hfbFilterOptionString`, { hfb }) +
        " - " +
        t(`hfb${hfb}String`),
    }));

    return options;
  }

  return useAllSelectOption({
    inputType: InputType.Select,
    filterType: FilterType.Filter,
    id: HFB_ID,
    title: t(title ?? "hfbString"),
    options: getOptions(),
    enabled: true,
    showSearch: true,
    defaultValue,
  });
}
